import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { Unsubscribe, doc, getFirestore, onSnapshot } from 'firebase/firestore';

import {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID
} from 'config';

export const FIRESTORE_USER_COLLECTION = 'users';
export const FIRESTORE_CRM_NOTIFICATION_COLLECTION = 'crm-notification';
export const FIRESTORE_CRM_NOTIFICATION_SUMMARY_DOC = 'summary';

export interface CrmNotificationSummary {
  unreadCount: number;
  updatedAt?: string;
}

const getFirebaseApp = (): FirebaseApp => {
  const existingApp = getApps()[0];
  if (existingApp) {
    return existingApp;
  }

  return initializeApp({
    apiKey: FIREBASE_API_KEY,
    projectId: FIREBASE_PROJECT_ID,
    authDomain: FIREBASE_AUTH_DOMAIN
  });
};

export const getCrmNotificationSummaryDocRef = (userId: string) => {
  const firestore = getFirestore(getFirebaseApp());
  return doc(
    firestore,
    FIRESTORE_USER_COLLECTION,
    userId,
    FIRESTORE_CRM_NOTIFICATION_COLLECTION,
    FIRESTORE_CRM_NOTIFICATION_SUMMARY_DOC
  );
};

export const subscribeToCrmNotificationUnreadCount = (
  userId: string,
  onUnreadCount: (unreadCount: number) => void,
  onError?: (error: Error) => void
): Unsubscribe => {
  const docRef = getCrmNotificationSummaryDocRef(userId);

  return onSnapshot(
    docRef,
    (snapshot) => {
      if (!snapshot.exists()) {
        onUnreadCount(0);
        return;
      }

      const data = snapshot.data() as CrmNotificationSummary;
      const unreadCount = Number(data?.unreadCount);
      onUnreadCount(Number.isFinite(unreadCount) ? unreadCount : 0);
    },
    (error) => {
      onError?.(error);
      onUnreadCount(0);
    }
  );
};
